export interface AlmeThemeModeToggleConfig {
    themeModeToggle: {
        label?: string;
    };
}

/**
 * This is the baseline theme mode toggle config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeThemeModeToggleConfig = {
    themeModeToggle: {
        label: 'Dark Mode',
    },
};

export default defaultConfig;